import React, { Component } from 'react';
import ShortEnrollmentDownload from './ShortEnrollmentDownload';
import ShortEnrollmentForm from './ShortEnrollmentForm';

class ShortEnrollmentDisplay extends Component {   
    render() {
        const { submitted, pdfUrl } = this.props;
        let displayView;

        if (submitted) {
            displayView = <ShortEnrollmentDownload pdfUrl={pdfUrl} />;
            document.querySelector("#enrollment-short > .white-bg").classList.remove("white-bg");
            document.getElementById("form-column").classList.remove("col-md-8");
            document.getElementById("enrollment-short").classList.add("submitted");
        } else {
            displayView = <ShortEnrollmentForm />;
        }
        return (
            displayView
        )
    }
}
  
export default ShortEnrollmentDisplay;